import React from "react";
import "./contactInfo.scss";
import { Phone, Facebook, Mail, Pin, Time } from "../../../icons";

const ContactInfo: React.FC = () => {
  return (
    <section className="contact-info">
      <div className="contact-info__container">
        <header className="contact-info__header">
          <div className="contact-info__header-top">
            <span className="contact-info__header-line" />
            <span className="contact-info__eyebrow">KONTAKT</span>
            <span className="contact-info__header-line" />
          </div>

          <h2 className="contact-info__title">Skontaktuj się z nami</h2>
          <p className="contact-info__description">
            Masz pytania dotyczące remontu lub wykończenia wnętrz? Chętnie
            doradzimy, odpowiemy na wszystkie wątpliwości i przygotujemy
            bezpłatną wycenę Twojego projektu.
          </p>
        </header>

        <div className="contact-info__grid">
          <div className="contact-info__item">
            <div className="contact-info__icon-box">
              <Phone className="contact-info__icon" />
            </div>
            <div className="contact-info__content">
              <span className="contact-info__label">Telefon</span>
              <a href="tel:530596229" className="contact-info__value">
                530 596 229
              </a>
              <p className="contact-info__subtext">Zadzwoń do nas</p>
            </div>
          </div>

          <div className="contact-info__item">
            <div className="contact-info__icon-box">
              <Mail className="contact-info__icon" />
            </div>
            <div className="contact-info__content">
              <span className="contact-info__label">Adres E-mail</span>
              <a
                href="mailto:studiowykonczeniowe@gmail.com"
                className="contact-info__value"
              >
                studiowykonczeniowe@gmail.com
              </a>
              <p className="contact-info__subtext">Napisz wiadomość</p>
            </div>
          </div>

          <div className="contact-info__item">
            <div className="contact-info__icon-box">
              <Time className="contact-info__icon" />
            </div>
            <div className="contact-info__content">
              <span className="contact-info__label">Godziny kontaktu</span>
              <p className="contact-info__value">Pon – Pt: 8:00 – 18:00</p>
              <p className="contact-info__subtext">Sob: 8:00 – 14:00</p>
            </div>
          </div>

          <div className="contact-info__item">
            <div className="contact-info__icon-box">
              <Pin className="contact-info__icon" />
            </div>
            <div className="contact-info__content">
              <span className="contact-info__label">Obszar Działania</span>
              <p className="contact-info__value">Dębica i okolice do 100km</p>
              <p className="contact-info__subtext">Podkarpacie i Małopolska</p>
            </div>
          </div>
        </div>

        <div className="contact-info__cta-card">
          <div className="contact-info__cta-text-wrapper">
            <h3 className="contact-info__cta-title">
              Chciałbyś poznać więcej naszych realizacji?
            </h3>
            <p className="contact-info__cta-subtitle">
              Zajrzyj na naszego Facebooka i zobacz, jak wyglądają efekty naszej
              pracy.
            </p>
          </div>
          <div className="contact-info__cta-actions">
            <a
              href="https://www.facebook.com/profile.php?id=61565814942600"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-info__button contact-info__button--secondary"
            >
              <Facebook />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactInfo;
